package com.eladfinish.bible.contest.entities

data class Parashot(private val namesAndSources: List<Pair<String, String>>) {

    val parashotNames by lazy { namesAndSources.map { it.first } } // פרשות השבוע
    val parashotSources by lazy { namesAndSources.map { it.second } } // מראי מקום תחילה וסוף

    val size = namesAndSources.size
}
